import { Video } from "lucide-react";
import PlaceholderPage from "./PlaceholderPage";

export default function Training() {
  return (
    <PlaceholderPage 
      title="Training Videos" 
      description="Access training videos and tutorials to help you maximize your use of the platform."
      icon={<Video size={48} />} 
    />
  );
}